export default function SFTriceIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.9739 21.8632L14 6.97855L12.0185 5L10.0261 6.9677L10 21.8502L11.9837 23L13.9739 21.8632Z"
        fill="#FF228C"
      />
      <path
        d="M4.97417 3.33261L8.39023 3.35003L9.06626 4.01198L8.38798 4.66739L4.97193 4.64997L4.58113 3.98802L4.97417 3.33261ZM4.1881 2L3 3.98367L4.17687 5.97387L8.95171 6L11 4.01851L8.96519 2.02613L4.19034 2H4.1881Z"
        fill="#8E1052"
      />
      <path
        d="M19.8231 2.02613L15.0483 2L13 3.98149L15.0371 5.97387L19.8119 6L21 4.01633L19.8231 2.02613Z"
        fill="#FF228C"
      />
    </svg>
  );
}
